import React, { useEffect, useState } from 'react'
import { Button, Dropdown, DropdownItemProps, Form, Header, Icon, Loader, Table, TableBody, TableCell, TableHeader, TableHeaderCell, TableRow } from 'semantic-ui-react';
import { operationReport } from '../../../app/models/Restoration';
import { toast } from 'react-toastify';
import {useStore} from '../../../app/stores/store';
const OperationalReport = () => {
  const { RestorationStore } = useStore();
  const [year, setyear] = useState<string>('');
  const [month, setmonth] = useState<string>('');
  const [loadData, setLoadData] = useState<operationReport[]>([]);
  const [laoding,setLoading]=useState<boolean>(false);
  const [years, setYears] = useState<DropdownItemProps[]>([]);

  useEffect(() => {
    const currentYear = new Date().getFullYear();
    setYears([
      { key: currentYear - 1, value: currentYear - 1, text: (currentYear - 1).toString() },
      { key: currentYear, value: currentYear, text: currentYear.toString() },
      { key: currentYear + 1, value: currentYear + 1, text: (currentYear + 1).toString() },
    ]);
  }, []);
  const ListOfMonth = [
    { key: 1, text: 'January', value: 'January' },
    { key: 2, text: 'February', value: 'February' },
    { key: 3, text: 'March', value: 'March'},
    { key: 4, text: 'April', value: 'April' },
    { key: 5, text: 'May', value: 'May' },
    { key: 6, text: 'June', value: 'June' },
    { key: 7, text: 'July', value: 'July' },
    { key: 8, text: 'August', value: 'August' },
    { key: 9, text: 'September', value: 'September' },
    { key: 10, text: 'October', value: 'October' },
    { key: 11, text: 'November', value: 'November' },
    { key: 12, text: 'December', value: 'December' },
  ]
  const handleMonthChange = (event:any, data:any) => {
    setmonth(data.value);
  };
  const handleYearChange = (event:any, data:any) => {
    setyear(data.value);
  };
  const dateBasedApiCall = async ()=> {
    try {
        setLoading(true);
        await RestorationStore.OperationReportAPICall(month,year);
        setLoadData(RestorationStore.operationReportType);
        setLoading(false);
    } catch (error) {
        toast.error('Error fetching data');

    }
};

const CsvConvert=()=>{
    const rows=[];
    
    const titleCodeRow=[
            'Fresh / Correction',
            'Client',
            'Title Name',
            'Teams',
            'FPS',
            'Estimated Hours',
            'Actual hours',
            'Recd Date',
            'Start Date',
            'Schedule Date',
            'Date of completion in production',
            'Date PCR was submitted',
            'Total Frames',
            'Complexity',
            'QC Rejected Frames',
            'QA Rejected Frames',
            'Remarks',
            'Title Code',
    ];
   
    rows.push(titleCodeRow.join(','));
    loadData.forEach(item => {
        const values = Object.values(item);
        rows.push(values.join(','));
    });
    const csvContent = rows.join('\n');
    return csvContent;
  }
  const handleDownload = () => {
    const csvContent = CsvConvert();
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8' });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `${month}_${year}_operationReport.csv`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
};
  return (
    <>
    <div className="title-wise-table" >
      <div style={{ display: 'flex', alignItems: 'center' }}> <Header> Operational Report Summary </Header><br/>
      </div>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <Form.Field>
          <div style={{ display: 'flex', alignItems: 'center' }}>
                  <div style={{ display: 'flex', alignItems: 'center', paddingLeft: '20px' }}>
                  <h4> Year : {'  '} </h4> 
                  <div style={{ display: 'flex', alignItems: 'center', paddingLeft: '20px' }}>
                  <Dropdown
                    placeholder='Year'
                    search
                    selection
                    options={years}
                    onChange={handleYearChange}
                    value={year}
                  />
                  
                    </div></div>
          <div style={{ display: 'flex', alignItems: 'center', paddingLeft: '20px' }}>
                  <h4> Month : {'  '} </h4>  </div>
                  <div style={{ display: 'flex', alignItems: 'center', paddingLeft: '20px' }}>
                  <Dropdown
                      placeholder='Month'
                      search
                      selection
                      options={ListOfMonth}
                      onChange={handleMonthChange}
                      value={month}
                    /></div>
                    
                    {month && year &&(
                      <div style={{ display: 'flex', alignItems: 'center', paddingLeft: '20px' }}>
                    <Button primary onClick={dateBasedApiCall}>View Report</Button></div>)}
                    </div>
          
          </Form.Field>
          <Form.Field>
                  <div style={{ display: 'flex', alignItems: 'center'}}>
                    {loadData.length !== 0 && (<Button onClick={handleDownload}><Icon className='download'/></Button>)}
                    </div>
                </Form.Field>
        </div>
        <br/>
        <div style={{maxHeight: '80vh', overflowY: 'auto' }}>
        { laoding ? <div><br/><Loader active inline='centered' > Loading </Loader></div>:
        <Table  className='ui celled table'>
        <TableHeader style={{ position: 'sticky', top: 0, zIndex: 1, background: 'white' }}>
          <TableRow>
            <TableHeaderCell>S.No</TableHeaderCell>
            <TableHeaderCell>Fresh / Correction</TableHeaderCell>
            <TableHeaderCell>Client</TableHeaderCell>
            <TableHeaderCell>Title Name</TableHeaderCell>
            <TableHeaderCell>Teams</TableHeaderCell>
            <TableHeaderCell>FPS</TableHeaderCell>
            <TableHeaderCell>Estimated Hours</TableHeaderCell>
            <TableHeaderCell>Actual hours</TableHeaderCell>
            <TableHeaderCell>Recd Date</TableHeaderCell>
            <TableHeaderCell>Start Date</TableHeaderCell>
            <TableHeaderCell>Schedule Date</TableHeaderCell>
            <TableHeaderCell>Date of completion in production</TableHeaderCell>
            <TableHeaderCell>Date PCR was submitted</TableHeaderCell>
            <TableHeaderCell>Total Frames</TableHeaderCell>
            <TableHeaderCell>Complexity</TableHeaderCell>
            <TableHeaderCell>QC Rejected Frames</TableHeaderCell>
            <TableHeaderCell>QA Rejected Frames</TableHeaderCell>
            <TableHeaderCell>Remarks</TableHeaderCell>
            <TableHeaderCell>Title Code</TableHeaderCell>
          </TableRow>
        </TableHeader>
    <TableBody>
    {loadData.length === 0 && (
                      <Table.Row>
                        <Table.Cell colSpan={17} textAlign="center">
                          Currently Data not Avaialabe
                        </Table.Cell>
                      </Table.Row>
                    )}
                        {loadData.map((item, index) => (
                            <TableRow key={index}>
                                <TableCell>{index+1}</TableCell>
                                <TableCell>{item.fresh_or_correction}</TableCell>
                                <TableCell>{item.client}</TableCell>
                                <TableCell>{item.titleName}</TableCell>
                                <TableCell style={{display: 'flex', whiteSpace: 'normal'}}>{item.teams}</TableCell>
                                <TableCell>{item.fps}</TableCell>
                                <TableCell>{item.estimateHours}</TableCell>
                                <TableCell>{item.actualHours}</TableCell>
                                <TableCell>{item.recd_Date}</TableCell>
                                <TableCell>{item.start_date}</TableCell>
                                <TableCell>{item.schedule_date}</TableCell>
                                <TableCell>{item.date_of_completion_in_production}</TableCell>
                                <TableCell>{item.pcR_was_submitted}</TableCell>
                                <TableCell>{item.total_Frames}</TableCell>
                                <TableCell>{item.complexity}</TableCell>
                                <TableCell>{item.qC_Rejected_Frames}</TableCell>
                                <TableCell>{item.qA_Rejected_Frames}</TableCell>
                                <TableCell>{item.remarks}</TableCell>
                                <TableCell>{item.titlecode}</TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
        </Table>}
        </div>
        </div>
    </>
  )
}

export default OperationalReport